import React, { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { getNotificationsSocket } from '@services/websocket/socket'
import { fetchPhoneManagementData } from '@store/actions/settings-communication.action'
import {
  NotificationCategory,
  NotificationTriggerType,
} from '@dataTypes/notification.types'

interface NotificationCreatedEvent {
  notification?: {
    clinic_id?: string | null
    clinicId?: string | null
    category?: string | null
    type?: string | null
  }
}

const PORT_REFRESH_TYPES = new Set<string>([
  NotificationTriggerType.PORT_REQUEST_APPROVED,
  NotificationTriggerType.PORT_REQUEST_DECLINED,
  NotificationTriggerType.PORT_REQUEST_RESUBMITTED,
  NotificationTriggerType.PORT_REQUEST_SUBMITTED,
])

const PortRequestSocketListener: React.FC = () => {
  const dispatch = useAppDispatch()
  const selectedClinic = useAppSelector((state) => state.clinic.selectedClinic)

  useEffect(() => {
    const handleNotificationCreated = (
      payload: NotificationCreatedEvent,
    ): void => {
      const notification = payload?.notification
      if (!notification) return
      if (notification.category !== NotificationCategory.CLINICS) return
      if (!notification.type || !PORT_REFRESH_TYPES.has(notification.type)) {
        return
      }
      if (!selectedClinic?.clinic_id) return
      const eventClinicId = notification.clinic_id ?? notification.clinicId
      if (eventClinicId && eventClinicId !== selectedClinic.clinic_id) {
        return
      }
      void dispatch(fetchPhoneManagementData(selectedClinic.clinic_id))
    }

    const socket = getNotificationsSocket()
    if (!socket) return

    socket.on('notification.created', handleNotificationCreated)
    return () => {
      socket.off('notification.created', handleNotificationCreated)
    }
  }, [dispatch, selectedClinic])

  return null
}

export default PortRequestSocketListener
